import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  private isCollapsed = new BehaviorSubject<boolean>(false);
  isCollapsed$ = this.isCollapsed.asObservable();

  toggleSidebar() {
    const currentStatus = this.isCollapsed.value;
    this.isCollapsed.next(!currentStatus);
  }

  expandSidebar() {
    this.isCollapsed.next(false);
  }

  toggleDarkMode(isDark: boolean) {
    if (isDark) {
      document.body.classList.add('dark');
      localStorage.setItem('themeSwitch', 'dark');
    } else {
      document.body.classList.remove('dark');
      localStorage.removeItem('themeSwitch');
    }
  }

  resetTheme(themeSwitchChecked: boolean) {
    if (themeSwitchChecked) {
      localStorage.setItem('themeSwitch', 'dark');
      this.updateTheme(true);
    } else {
      localStorage.removeItem('themeSwitch');
      this.updateTheme(false);
    }
  }

  updateTheme(isDark: boolean) {
    if (isDark) {
      document.body.setAttribute('data-theme', 'dark');
      this.toggleDarkMode(isDark);
    } else {
      document.body.removeAttribute('data-theme');
      this.toggleDarkMode(isDark);
    }
  }
}
